import { render, staticRenderFns } from "./ChapterImages.vue?vue&type=template&id=488fdcb5&"
import script from "./ChapterImages.vue?vue&type=script&lang=js&"
export * from "./ChapterImages.vue?vue&type=script&lang=js&"
import style0 from "./ChapterImages.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports